import type { Metric } from '@atlassian/browser-metrics/metric';
import type { PageSegmentLoadMetric } from '@atlassian/browser-metrics/page-segment-load';

import {
	createPageSegmentLoadMetric,
	createInteractionMetric,
} from '@confluence/browser-metrics/entry-points/metricConfigs.ts';
import {
	RESTRICTIONS_BUTTON_SEGMENT_KEY,
	RESTRICTIONS_DIALOG_INTERACTION,
} from '@confluence/browser-metrics/entry-points/metric-keys.ts';

export const RESTRICTIONS_BUTTON_METRIC: PageSegmentLoadMetric = createPageSegmentLoadMetric({
	key: RESTRICTIONS_BUTTON_SEGMENT_KEY,
	timings: [
		{
			key: 'fmp',
			endMark: 'fmp',
		},
		{
			key: 'tti',
			endMark: 'tti',
		},
	],
});

export const RESTRICTIONS_DIALOG_METRIC: Metric = createInteractionMetric({
	key: RESTRICTIONS_DIALOG_INTERACTION,
});
